import { NgModule } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { CommonErrorStateMatcher } from 'wflow-main-app/src/app/shared/modules/material/cusErrorStateMatchers';

@NgModule({
  providers: [
    { provide: ErrorStateMatcher, useClass: CommonErrorStateMatcher },
  ],
})
export class MatModule {}
